/* eslint-disable react/jsx-no-comment-textnodes */
import emailjs from "@emailjs/browser";
import { Button, TextField } from "@mui/material";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import React, { useEffect, useRef, useState } from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AnimatedLetter from "../../AnimatedLetters";
import "./index.scss";

const Contact = () => {
  const textArray = "Contact".split("");
  const [letterClass, setLetterClass] = useState("text-animate");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const { name, email, subject, message } = formData;
  const formRef = useRef();
  const myLocation = [23.126678, 90.6881493];

  const customIcon = new Icon({
    iconUrl: require("../../../assets/image/location-pin.png"),
    iconSize: [30, 30],
    // iconAnchor: [1, 1],
    // popupAnchor: [-0, -76]
  });

  const formValidation = () => {
    if (name === "" || email === "" || subject === "" || message === "") {
      toast.error("All input fields are required", {
        position: "bottom-right",
        autoClose: 4000,
        theme: "dark",
        pauseOnHover: true,
        draggable: true,
        Limit: 1,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const sendEmail = (e) => {
    e.preventDefault();
    formValidation();

    emailjs
      .sendForm(
        "service_7n9u8yx",
        "template_awrtm5f",
        formRef.current,
        "9V34m0Jj5Yom1MVFG"
      )
      .then(() => {
        toast.success("Message sent successfully & wait for response", {
          position: "bottom-right",
          autoClose: 5000,
          theme: "dark",
          pauseOnHover: true,
          draggable: true,
          Limit: 1,
        });
        setTimeout(() => {
          window.location.reload(false);
        }, 3000);
      })
      .catch((err) => {
        toast.error("Failed to send the Email, please try again", {
          position: "bottom-right",
          autoClose: 4000,
          theme: "dark",
          pauseOnHover: true,
          draggable: true,
          Limit: 1,
        });
      });
  };

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1 className="header-h1">
          <AnimatedLetter
            strArray={textArray}
            idx={15}
            letterClass={letterClass}
          />
        </h1>
        <p className="sub-text">Contact Me</p>
      </div>

      <main className="contact-main">
        <div className="contact-form">
          <div className="text-zone">
            <p>
              I am interested in freelanch opportunities - especially ambitious
              or large projects. However, if you have other request or quition,
              don't hesitate to contact me using below form either.
            </p>
          </div>
          <form onSubmit={sendEmail} ref={formRef}>
            <div className="half">
              <TextField
                className="half-inp"
                id="outlined-basic"
                label="Name"
                variant="outlined"
                type="text"
                name="name"
                onChange={handleChange}
                required
              />
              <TextField
                className="half-inp"
                id="outlined-basic"
                label="Email"
                variant="outlined"
                type="email"
                name="email"
                onChange={handleChange}
                required
              />
            </div>
            <div className="full">
              <TextField
                className="full-inp"
                id="outlined-basic"
                label="Subject"
                fullWidth
                variant="outlined"
                type="text"
                name="subject"
                onChange={handleChange}
                required
              />
              <TextField
                className="full-textaria"
                id="outlined-basic"
                fullWidth
                multiline
                rows={8}
                label="Message"
                variant="outlined"
                type="text"
                name="message"
                onChange={handleChange}
                required
              />
            </div>
            <Button type="submit" className="send-btn">
              Send
            </Button>
          </form>
        </div>
        <div className="contact-map">
          {/* <div className="info-map">
            Taifur Islam,
            <br />
            Bangladesh,
            <br />
            Mission Road, Chandpur, 685 <br />
            Faridgang, Chandpur <br />
            <hr />
            <Tooltip title="Click & call now" placement="top">
              <a href="tel:+8801645120517">
                <AiFillPhone />
                +8801645120517
              </a>
            </Tooltip>
            <br />
            <Tooltip title="Click & send mail" placement="bottom">
              <a href="mailto:Taifurislamashraf.bd@gmail.com">
                <AiFillMail /> Taifurislamashraf.bd@gmail.com
              </a>
            </Tooltip>
          </div> */}
          <div>
            <MapContainer className="map" center={myLocation} zoom={13}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              <Marker position={myLocation} icon={customIcon}>
                <Popup>
                  <p>Taifur lives here, come over for a cup of coffee :)</p>
                </Popup>
              </Marker>
            </MapContainer>
          </div>
        </div>
      </main>
      <ToastContainer />
    </div>
  );
};

export default Contact;
